// extracted by css-extract-rspack-plugin
export default {"trigger":"Tooltip-module__trigger__maIWw","tooltip":"Tooltip-module__tooltip__pphzm"};